import { render } from "./customerSelect.vue?vue&type=template&id=622d0324&scoped=true&ts=true"
import script from "./customerSelect.vue?vue&type=script&lang=ts"
export * from "./customerSelect.vue?vue&type=script&lang=ts"

import "./customerSelect.vue?vue&type=style&index=0&id=622d0324&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622d0324"]])

export default __exports__